<template>
  <v-card style="margin-top: 2rem; padding: 25px; border-radius: 12px;">
    <v-card-title>
      <span
        class="headline"
        style="color: #181618"
      >
        {{ $t("Do you want to buy credits for AI-generated content?") }}
      </span>
    </v-card-title>

    <v-card-text>
      <p style="margin-top: 10px; color: #181618">{{ $t("selectDesiredAmount") }}</p>

      <v-row>
        <!-- Botões de seleção de créditos -->
        <v-col
          v-for="credits in [25, 50, 100, 300]"
          :key="credits"
          cols="6"
          lg="6"
          md="8"
          sm="12"
        >
          <v-btn
            :color="selectedCredits === credits ? '#ffc975' : '#ffebcc'"
            style="max-width: 147px; border-radius: 10px"
            :style="{
              border: selectedCredits === credits ? '3px solid #d97f00' : '2px solid #f2c27f' }"
            @click="startCheckout(credits)"
          >
            <div
              :style="{
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                border: selectedCredits === credits ? '2px solid #3d2400' : '2px solid #f2c27f'
              }"
            >
              <v-icon
                :color="selectedCredits === credits ? '#3d2400' : '#f2c27f'"
                style="font-size: 18px;"
              >
                mdi-currency-usd
              </v-icon>
            </div>
            <span style="margin-left: 5px; color: #3d2400; text-transform: none;">
              {{ credits }} {{ $t('Credits') }}
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);

export default {
  name: 'StripePayment',
  props: {
    idCustomer: Number,
    userToken: String,
    userEmail: String,
  },
  data() {
    return {
      showModal: false,
      selectedCredits: 0,
      userData: JSON.parse(localStorage.getItem('user')),
      customerData: {},
    };
  },

  methods: {
    async startCheckout(credits) {
      try {
        this.selectedCredits = credits;
        const selectedAmount = this.selectedCredits * 100;
        const metadata = {
          customerid: this.idCustomer,
          email: this.userEmail,
          transcription: this.$route.fullPath,
        };
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/stripe/create-checkout-session`, {
          payment_method_types: ['card'],
          line_items: [
            {
              price_data: {
                currency: 'brl',
                product_data: { name: `IA Creditos - ${credits}` },
                unit_amount: selectedAmount,
              },
              quantity: 1,
            },
          ],
          metadata,
          payment_intent_data: {
            metadata,
          },
          success_url: `${window.location.origin}/payments/stripe/success?session_id={CHECKOUT_SESSION_ID}&hash=${this.userToken}`,
          cancel_url: `${window.location.origin}/payments/stripe/cancel?session_id={CHECKOUT_SESSION_ID}&hash=${this.userToken}`,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        console.log('Sessão de checkout criada:', response.data.id);
        const sessionId = response.data.id;
        const stripe = await stripePromise;
        await stripe.redirectToCheckout({ sessionId });
      } catch (error) {
        console.error('Erro ao criar sessão de checkout:', error);
      }
    },
  },

};
</script>
